import { render, staticRenderFns } from "./sendEmail.vue?vue&type=template&id=68e91494&scoped=true&"
import script from "./sendEmail.vue?vue&type=script&lang=js&"
export * from "./sendEmail.vue?vue&type=script&lang=js&"
import style0 from "./sendEmail.vue?vue&type=style&index=0&id=68e91494&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e91494",
  null
  
)

export default component.exports